// extracted by mini-css-extract-plugin
export default {"wrapper":"form-submit_wrapper__PPOVs"};